<template>
  <header
    class="main-header"
    :class="{ 'is-open': megaOpen, 'is-subpage': isSubpage, 'mobile-open': mobileMenuOpen, 'force-mobile': isMobileRoute }"
    @mouseleave="megaOpen = false"
  >
    <!-- 1단: 로고 중앙 + 우측 전화 -->
    <div class="top-bar">
      <div class="top-inner">
        <div class="top-side"></div>
        <router-link to="/" class="logo" @click="closeMobileMenu">
          <img src="@/assets/logo/logo_text.png" alt="레이원시티" class="logo-img" />
        </router-link>
        <div class="top-side top-right">
          <a href="tel:1877-4088" class="phone-btn">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.11 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            <span class="phone-num">1877-4088</span>
          </a>
          <div class="visit-counter">
            <span class="visit-item">일일 방문 <strong>{{ dailyVisit.toLocaleString() }}</strong>명</span>
            <span class="visit-divider">|</span>
            <span class="visit-item">누적 방문 <strong>{{ totalVisit.toLocaleString() }}</strong>명</span>
          </div>
          <!-- 모바일 햄버거 버튼 -->
          <button
            class="hamburger-btn"
            :class="{ 'is-active': mobileMenuOpen }"
            @click="toggleMobileMenu"
            aria-label="메뉴 열기"
          >
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- 2단: 메뉴 full-width 균등 + 방문자수 오른쪽 끝 (데스크톱 전용) -->
    <div class="menu-bar">
      <div class="menu-bar-outer">
        <nav class="menu-nav" @mouseenter="megaOpen = true">
          <div
            v-for="(menu, index) in menuData"
            :key="index"
            class="menu-item"
            @mouseenter="activeMenu = index"
          >
            <router-link
              :to="menu.children[0].path"
              class="menu-link"
              :class="{ active: megaOpen && activeMenu === index }"
              @click="megaOpen = false"
            >{{ menu.title }}</router-link>
          </div>
        </nav>
      </div>
    </div>

    <!-- 메가메뉴: 전체 서브메뉴 동시 노출 (데스크톱) -->
    <div class="mega-panel" :class="{ 'is-visible': megaOpen }">
      <div class="mega-panel-outer">
        <div class="mega-grid">
          <div
            v-for="(menu, index) in menuData"
            :key="index"
            class="mega-col"
          >
            <ul class="sub-list">
              <li v-for="(sub, si) in menu.children" :key="si">
                <router-link :to="sub.path" class="sub-link" @click="megaOpen = false">{{ sub.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- 방문자수 자리만큼 빈 공간 -->
        <div class="mega-spacer"></div>
      </div>
    </div>

    <!-- 모바일 풀스크린 메뉴 -->
    <div class="mobile-menu" :class="{ 'is-visible': mobileMenuOpen }">
      <div class="mobile-menu-inner">
        <nav class="mobile-nav">
          <div
            v-for="(menu, index) in menuData"
            :key="index"
            class="mobile-menu-group"
          >
            <button
              class="mobile-menu-title"
              :class="{ 'is-expanded': expandedMenu === index }"
              @click="toggleAccordion(index)"
            >
              <span>{{ menu.title }}</span>
              <svg class="mobile-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
            <div class="mobile-sub-list" :class="{ 'is-expanded': expandedMenu === index }">
              <router-link
                v-for="(sub, si) in menu.children"
                :key="si"
                :to="sub.path"
                class="mobile-sub-link"
                @click="closeMobileMenu"
              >{{ sub.title }}</router-link>
            </div>
          </div>
        </nav>
        <div class="mobile-menu-footer">
          <a href="tel:1877-4088" class="mobile-phone-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.11 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            <span>1877-4088</span>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MainHeader',
  computed: {
    isSubpage() {
      return this.$route.meta.layout !== 'home'
    },
    isMobileRoute() {
      return this.$route.meta.layout === 'mobile'
    }
  },
  data() {
    return {
      megaOpen: false,
      activeMenu: 0,
      mobileMenuOpen: false,
      expandedMenu: null,
      dailyVisit: 405,
      totalVisit: 501999,
      menuData: [
        {
          title: '사업안내',
          children: [
            { title: '사업개요', path: '/intro/overview' },
            { title: '브랜드', path: '/intro/brand' }
          ]
        },
        {
          title: '입지안내',
          children: [
            { title: '입지환경', path: '/location/environment' },
            { title: '어라운드뷰', path: '/location/around' }
          ]
        },
        {
          title: '상품안내',
          children: [
            { title: '단지정보', path: '/product/complex' },
            { title: '프리미엄', path: '/product/premium' },
            { title: '커뮤니티', path: '/product/community' }
          ]
        },
        {
          title: '세대안내',
          children: [
            { title: '59㎡', path: '/type/59' },
            { title: '74㎡', path: '/type/74' },
            { title: '84㎡A', path: '/type/84A' },
            { title: '84㎡A-1', path: '/type/84A-1' },
            { title: '84㎡B', path: '/type/84B' }
          ]
        },
        {
          title: '홍보센터',
          children: [
            { title: '홍보영상', path: '/media/video' }
          ]
        },
        {
          title: '방문예약',
          children: [
            { title: '관심고객등록', path: '/reservation/register' }
          ]
        }
      ]
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      if (this.mobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
        this.expandedMenu = null
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
      document.body.style.overflow = ''
      this.expandedMenu = null
    },
    toggleAccordion(index) {
      this.expandedMenu = this.expandedMenu === index ? null : index
    }
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.main-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* ===== 1단: 로고 바 ===== */
.top-bar {
  background: transparent;
  transition: background 0.35s ease;
}

.main-header.is-open .top-bar {
  background: #fff;
}

.top-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 48px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-side { flex: 1; }
.top-right { display: flex; justify-content: flex-end; }

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-img {
  height: 46px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  transition: filter 0.35s ease;
}

.main-header.is-open .logo-img {
  filter: none;
}

/* 전화 */
.phone-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  text-decoration: none;
  color: #fff;
  padding: 7px 16px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.phone-btn:hover {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.06);
}

.main-header.is-open .phone-btn {
  color: #555;
  border-color: #ddd;
}

.main-header.is-open .phone-btn:hover {
  color: var(--rayone-primary);
  border-color: var(--rayone-primary);
  background: rgba(163, 32, 53, 0.05);
}

.phone-num {
  font-family: var(--font-paperlogy);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
}

/* ===== 2단: 메뉴 바 ===== */
.menu-bar {
  background: transparent;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.35s ease;
}

.main-header.is-open .menu-bar {
  background: #fff;
  border-top-color: #e8e8e8;
  border-bottom-color: #e8e8e8;
}

.menu-bar-outer {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 48px;
  display: flex;
  align-items: center;
}

/* 메뉴 — 중앙 모음 */
.menu-nav {
  display: flex;
  width: 70%;
  margin: 0 auto;
}

.menu-item {
  flex: 1;
  text-align: center;
}

.menu-link {
  display: block;
  padding: 14px 0;
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  letter-spacing: 0.3px;
  transition: color 0.2s ease;
  position: relative;
}

.menu-link:hover,
.menu-link.active {
  color: #fff;
}

.menu-link.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--rayone-primary);
}

/* 열렸을 때 메뉴 색상 */
.main-header.is-open .menu-link {
  color: #666;
}

.main-header.is-open .menu-link:hover,
.main-header.is-open .menu-link.active {
  color: #111;
  font-weight: 600;
}

/* 방문자수 — 메뉴 밖, 오른쪽 끝 고정 */
.visit-counter {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-shrink: 0;
  margin-left: 32px;
  padding: 7px 16px;
  background: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 3px;
}

.visit-item {
  font-family: var(--font-pretendard);
  font-size: 13px;
  color: #1a2744;
  white-space: nowrap;
}

.visit-item strong {
  font-family: var(--font-paperlogy);
  font-weight: 700;
  color: #1a2744;
  margin-left: 3px;
}

.visit-divider {
  color: #1a2744;
  font-size: 13px;
  opacity: 0.3;
}

/* ===== 메가메뉴 ===== */
.mega-panel {
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
  opacity: 0;
}

.mega-panel.is-visible {
  max-height: 400px;
  opacity: 1;
}

.mega-panel-outer {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 48px;
  display: flex;
}

.mega-grid {
  display: flex;
  width: 70%;
  margin: 0 auto;
  padding: 24px 0 32px;
}

.mega-col {
  flex: 1;
  text-align: center;
}

.mega-spacer {
  display: none;
}

.sub-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}


.sub-link {
  display: inline-block;
  padding: 6px 12px;
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 400;
  color: #555;
  text-decoration: none;
  transition: color 0.2s ease, background 0.2s ease;
  border-radius: 3px;
}

.sub-link:hover {
  color: var(--rayone-primary);
  background: rgba(163, 32, 53, 0.06);
}

/* ===== 서브페이지 ===== */
.main-header.is-subpage .top-bar {
  background: #fff;
}

.main-header.is-subpage .logo-img {
  filter: none;
}

.main-header.is-subpage .phone-btn {
  color: #555;
  border-color: #ddd;
}

.main-header.is-subpage .phone-btn:hover {
  color: var(--rayone-primary);
  border-color: var(--rayone-primary);
  background: rgba(163, 32, 53, 0.05);
}

.main-header.is-subpage .menu-bar {
  background: #fff;
  border-top-color: #e8e8e8;
  border-bottom-color: #e8e8e8;
}

.main-header.is-subpage .menu-link {
  color: #666;
}

.main-header.is-subpage .menu-link:hover,
.main-header.is-subpage .menu-link.active {
  color: #111;
  font-weight: 600;
}

/* ===== 반응형 ===== */
@media (max-width: 1100px) {
  .menu-link { font-size: 14px; }
  .sub-link { font-size: 13px; }
  .visit-counter { display: none; }
  .mega-spacer { display: none; }
}

@media (max-width: 900px) {
  .top-inner { padding: 0 20px; height: 50px; }
  .menu-bar-outer { padding: 0 20px; }
  .logo-img { height: 32px; }
  .menu-link { padding: 12px 0; font-size: 13px; }
  .phone-num { display: none; }
  .phone-btn { padding: 8px; border-radius: 50%; }
}

/* ============================================
   햄버거 버튼 (데스크톱에서는 숨김)
   ============================================ */
.hamburger-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  margin-left: 8px;
  background: none;
  border: none;
  cursor: pointer;
  gap: 5px;
  -webkit-tap-highlight-color: transparent;
}

.hamburger-line {
  display: block;
  width: 22px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

/* 서브페이지 / 메뉴열림 시 햄버거 색상 */
.main-header.is-subpage .hamburger-line,
.main-header.mobile-open .hamburger-line {
  background: #333;
}

/* 햄버거 → X 애니메이션 */
.hamburger-btn.is-active .hamburger-line:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.hamburger-btn.is-active .hamburger-line:nth-child(2) {
  opacity: 0;
}
.hamburger-btn.is-active .hamburger-line:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ============================================
   모바일 풀스크린 메뉴 (데스크톱에서는 숨김)
   ============================================ */
.mobile-menu {
  display: none;
}

/* ============================================
   모바일 반응형 (max-width: 768px)
   ============================================ */
@media (max-width: 768px) {
  /* --- 햄버거 표시 --- */
  .hamburger-btn {
    display: flex;
  }

  /* --- 데스크톱 메뉴바 / 메가패널 숨김 --- */
  .menu-bar {
    display: none;
  }
  .mega-panel {
    display: none;
  }

  /* --- 헤더 탑바 조정 --- */
  .top-inner {
    padding: 0 16px;
    height: 56px;
  }

  .top-side:first-child {
    display: none;
  }

  .logo {
    margin-right: auto;
  }

  .logo-img {
    height: 32px;
  }

  /* --- 전화 버튼 모바일 --- */
  .phone-btn {
    width: 44px;
    height: 44px;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
  .phone-btn svg {
    width: 18px;
    height: 18px;
  }
  .phone-num {
    display: none;
  }

  /* --- 방문자수 숨김 --- */
  .visit-counter {
    display: none;
  }

  /* --- 모바일 메뉴 열림 시 헤더 배경 --- */
  .main-header.mobile-open .top-bar {
    background: #fff;
  }
  .main-header.mobile-open .logo-img {
    filter: none;
  }
  .main-header.mobile-open .phone-btn {
    color: #555;
    border-color: #ddd;
  }

  /* --- 모바일 풀스크린 메뉴 --- */
  .mobile-menu {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;
    padding-top: 56px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    transform: translateX(100%);
    transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    visibility: hidden;
  }

  .mobile-menu.is-visible {
    transform: translateX(0);
    visibility: visible;
  }

  .mobile-menu-inner {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 56px);
    padding: 16px 0 32px;
  }

  /* --- 모바일 네비게이션 --- */
  .mobile-nav {
    flex: 1;
  }

  .mobile-menu-group {
    border-bottom: 1px solid #f0f0f0;
  }

  .mobile-menu-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 24px;
    min-height: 52px;
    font-family: var(--font-pretendard);
    font-size: 17px;
    font-weight: 600;
    color: #222;
    background: none;
    border: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .mobile-menu-title:active {
    background: #f8f8f8;
  }

  .mobile-arrow {
    color: #999;
    transition: transform 0.3s ease;
    flex-shrink: 0;
  }

  .mobile-menu-title.is-expanded .mobile-arrow {
    transform: rotate(180deg);
    color: var(--rayone-primary);
  }

  .mobile-menu-title.is-expanded {
    color: var(--rayone-primary);
  }

  /* --- 모바일 서브메뉴 아코디언 --- */
  .mobile-sub-list {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    background: #fafafa;
  }

  .mobile-sub-list.is-expanded {
    max-height: 400px;
  }

  .mobile-sub-link {
    display: block;
    padding: 14px 24px 14px 40px;
    min-height: 44px;
    font-family: var(--font-pretendard);
    font-size: 15px;
    font-weight: 400;
    color: #555;
    text-decoration: none;
    transition: color 0.2s ease, background 0.2s ease;
    line-height: 1;
    display: flex;
    align-items: center;
  }

  .mobile-sub-link:active {
    background: #f0f0f0;
    color: var(--rayone-primary);
  }

  /* --- 모바일 메뉴 하단 전화번호 --- */
  .mobile-menu-footer {
    padding: 24px;
    border-top: 1px solid #f0f0f0;
    margin-top: 16px;
  }

  .mobile-phone-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 14px 20px;
    min-height: 52px;
    font-family: var(--font-paperlogy);
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    background: var(--rayone-primary);
    border-radius: 8px;
    text-decoration: none;
    letter-spacing: 1px;
    -webkit-tap-highlight-color: transparent;
  }

  .mobile-phone-btn:active {
    opacity: 0.85;
  }

  .mobile-phone-btn svg {
    flex-shrink: 0;
  }
}

/* ============================================
   초소형 모바일 (max-width: 380px)
   ============================================ */
@media (max-width: 380px) {
  .top-inner {
    padding: 0 12px;
    height: 48px;
  }

  .logo-img {
    height: 28px;
  }

  .mobile-menu {
    padding-top: 48px;
  }

  .mobile-menu-inner {
    min-height: calc(100vh - 48px);
  }

  .mobile-menu-title {
    padding: 14px 20px;
    font-size: 16px;
  }

  .mobile-sub-link {
    padding: 12px 20px 12px 36px;
    font-size: 14px;
  }

  .mobile-phone-btn {
    font-size: 16px;
    padding: 12px 16px;
  }
}

/* ============================================
   /mobile 라우트 전용 - 화면 너비 무관하게 모바일 헤더 강제
   (위 @media 768px 규칙을 .force-mobile 로 복제)
   ============================================ */
.main-header.force-mobile .hamburger-btn {
  display: flex;
}

.main-header.force-mobile .menu-bar,
.main-header.force-mobile .mega-panel {
  display: none;
}

.main-header.force-mobile .top-inner {
  padding: 0 16px;
  height: 56px;
}

.main-header.force-mobile .top-side:first-child {
  display: none;
}

.main-header.force-mobile .logo {
  margin-right: auto;
}

.main-header.force-mobile .logo-img {
  height: 32px;
}

.main-header.force-mobile .phone-btn {
  width: 44px;
  height: 44px;
  padding: 0;
  justify-content: center;
  border-radius: 50%;
}
.main-header.force-mobile .phone-btn svg {
  width: 18px;
  height: 18px;
}
.main-header.force-mobile .phone-num {
  display: none;
}

.main-header.force-mobile .visit-counter {
  display: none;
}

.main-header.force-mobile.mobile-open .top-bar {
  background: #fff;
}
.main-header.force-mobile.mobile-open .logo-img {
  filter: none;
}
.main-header.force-mobile.mobile-open .phone-btn {
  color: #555;
  border-color: #ddd;
}

.main-header.force-mobile .mobile-menu {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 999;
  padding-top: 56px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transform: translateX(100%);
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  visibility: hidden;
}

.main-header.force-mobile .mobile-menu.is-visible {
  transform: translateX(0);
  visibility: visible;
}

.main-header.force-mobile .mobile-menu-inner {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 56px);
  padding: 16px 0 32px;
}

.main-header.force-mobile .mobile-nav {
  flex: 1;
}

.main-header.force-mobile .mobile-menu-group {
  border-bottom: 1px solid #f0f0f0;
}

.main-header.force-mobile .mobile-menu-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 24px;
  min-height: 52px;
  font-family: var(--font-pretendard);
  font-size: 17px;
  font-weight: 600;
  color: #222;
  background: none;
  border: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.main-header.force-mobile .mobile-menu-title:active {
  background: #f8f8f8;
}

.main-header.force-mobile .mobile-arrow {
  color: #999;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.main-header.force-mobile .mobile-menu-title.is-expanded .mobile-arrow {
  transform: rotate(180deg);
  color: var(--rayone-primary);
}

.main-header.force-mobile .mobile-menu-title.is-expanded {
  color: var(--rayone-primary);
}

.main-header.force-mobile .mobile-sub-list {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  background: #fafafa;
}

.main-header.force-mobile .mobile-sub-list.is-expanded {
  max-height: 400px;
}

.main-header.force-mobile .mobile-sub-link {
  padding: 14px 24px 14px 40px;
  min-height: 44px;
  font-family: var(--font-pretendard);
  font-size: 15px;
  font-weight: 400;
  color: #555;
  text-decoration: none;
  transition: color 0.2s ease, background 0.2s ease;
  line-height: 1;
  display: flex;
  align-items: center;
}

.main-header.force-mobile .mobile-sub-link:active {
  background: #f0f0f0;
  color: var(--rayone-primary);
}

.main-header.force-mobile .mobile-menu-footer {
  padding: 24px;
  border-top: 1px solid #f0f0f0;
  margin-top: 16px;
}

.main-header.force-mobile .mobile-phone-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px 20px;
  min-height: 52px;
  font-family: var(--font-paperlogy);
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  background: var(--rayone-primary);
  border-radius: 8px;
  text-decoration: none;
  letter-spacing: 1px;
  -webkit-tap-highlight-color: transparent;
}

.main-header.force-mobile .mobile-phone-btn:active {
  opacity: 0.85;
}

.main-header.force-mobile .mobile-phone-btn svg {
  flex-shrink: 0;
}
</style>
